import Vue from 'vue';
import Mint from 'mint-ui';
import router from '../router';
import 'animate.css'
import 'element-ui/lib/theme-chalk/index.css';
import store from './store'
import VueAnimateNumber from 'vue-animate-number'
import * as echarts from 'echarts'
import BaiduMap from 'vue-baidu-map'
import './utils/rem'

Vue.use( BaiduMap, { ak : 'GG3wB6XEFH2flrH1eQVmGeE1soxjRGdl' } )
Vue.prototype.$echarts = echarts
Vue.use(VueAnimateNumber)
Vue.use(Mint);
Vue.config.productionTip = false
// 跳转路由显示loading状态
router.beforeEach((to, from, next) => {
  store.dispatch('onLoading', true);
  next();
});
// 这里为了让效果明显一些加了延时
router.afterEach((to, from) => {
    setTimeout(function() {
      store.dispatch('onLoading', false);
    }, 1000);
  });
import VueI18n from 'vue-i18n';
import Langcn from '../lang/cn';
import Langen from '../lang/en';
Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: 'cn',    // 语言标识
    messages: {
        'cn': Langcn,   // 中文语言包
        'en': Langen    // 英文语言包
    },
})
import Vuex from 'vuex';
// import store from '../store';
Vue.use(Vuex);
import '@/assets/css/aui_iconfont.ttf';
import 'mint-ui/lib/style.css';
import '@/assets/scss/style.scss';
import '@/assets/css/animate.min.css';
import axios from 'axios';
Vue.prototype.$http = axios;
var res = require('vue-resource');
Vue.prototype.$reshttp = res.Http;
import App from '@/App';
import global_ from '@/config';//引用文件
Vue.prototype.config = global_//挂载到Vue实例上面


import carousel from 'vue-owl-carousel'
Vue.use(carousel);
import VueUeditorWrap from 'vue-ueditor-wrap';
// Vue.use(VueUeditorWrap)
Vue.component('vue-ueditor-wrap', VueUeditorWrap);


import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
Vue.use(VueAwesomeSwiper);

import Vuecheckin from 'vue-checkin';
Vue.use(Vuecheckin);

import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

import iView from 'iview';
import 'iview/dist/styles/iview.css';
Vue.use(iView, {
    i18n: function(path, options) {
        let value = i18n.t(path, options)
        if (value !== null && value !== undefined) {
            return value
        }
        return ''
    }
})

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import VueLazyload from 'vue-lazyload';  //引入这个懒加载插件
// 或者添加VueLazyload 选项
Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: require('@/assets/image/df_img.png'),   //请求失败后显示的图片
    loading: require('@/assets/image/loading.gif'),   //加载的loading过渡图片
    attempt: 1,     // 加载图片数量
    lazyComponent:true,
    dispatchEvent:true,
    observer:true,
    listenEvents:['scroll','wheel','mousewheel','resize','animationend','transitionend','touchmove'], //你想让vue监听的事件
})

import vshare from 'vshare';
Vue.use(vshare);

// import SpriteSpin from "spritespin";
// Vue.use(SpriteSpin);

import Common from '../common/common.js';
Vue.use(Common);

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

//seo
import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)

import * as filters from '../filters/filter.js';
Object.keys(filters).forEach(key=>{
    Vue.filter(key,filters[key])
})


var is_api = false;

if(is_api){
    window.apiready = function() {
    new Vue({
            store,
            swiper,
            swiperSlide,
            carousel,
            i18n,
            el: '#app',
            router,
            render: h => h(App),
            mounted(){
                document.dispatchEvent(new Event('render-event'))
                // document.dispatchEvent(new Event('custom-render-trigger'))
            }
        })
    }
}else{
    new Vue({
        store,
        swiper,
        swiperSlide,
        carousel,
        i18n,
        el: '#app',
        router,
        components: { App },
        render: h => h(App),
        mounted(){
            document.dispatchEvent(new Event('render-event'))
            // document.dispatchEvent(new Event('custom-render-trigger'))
        }
    })
}




// WEBPACK FOOTER //
// ./src/main.js